module.exports = "pegasus/assets/blocks/column-6-theme2.png";